import { render } from "./SetupMeeting.vue?vue&type=template&id=3ee059a1"
import script from "./SetupMeeting.vue?vue&type=script&lang=js"
export * from "./SetupMeeting.vue?vue&type=script&lang=js"

import "./SetupMeeting.vue?vue&type=style&index=0&id=3ee059a1&lang=scss"

import exportComponent from "C:\\Users\\john doe\\Documents\\Venice\\vnc\\AgendaBuilder\\agenda\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__